import type { LanguageCode } from 'iso-639-1'

/**
 * Language level (CEFR)
 */
export enum LanguageLevel {
    A1 = 'A1',
    A2 = 'A2',
    B1 = 'B1',
    B2 = 'B2',
    C1 = 'C1',
    C2 = 'C2'
}

/**
 * Language
 */
export type Language = {
    /**
     * Language code (ISO 639-1)
     */
    code: LanguageCode
    /**
     * Language level (CEFR)
     */
    level: LanguageLevel
}
